// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "5156829b0",
    "hash": "5156829b0",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "5156829b0",
    "semverString": null,
    "version": "0.0.0",
    "buildDate": "11/4/2026",
    "buildTime": "Wed, 04 Nov 2026 22:38:38 GMT"
};
/* eslint:enable */
